export const environnementStats = [
  {
    key: 'environnement-energie',
    value: '91%',
    text: 'd’énergie d’origine renouvelable',
  },
  {
    key: 'environnement-datacenters',
    value: '25%',
    text: 'des datacenters issus de rénovation',
  },
  {
    key: 'environnement-pieces',
    value: '36%',
    text: 'de pièces réemployées',
  },
  {
    key: 'environnement-eau',
    value: '7x',
    text: 'de consommation d’eau réduite',
  },
  {
    key: 'environnement-pue',
    value: '1,29',
    text: 'PUE contre 1,57 en moyenne dans le secteur',
  },
]
